module.exports = __webpack_public_path__ + "static/media/ana-gabriella.dfbf3927.bin";